<template>
  <div class="site-logo-title">
    <div
      class="site-logo-title__main"
    >
      CRA Freelance
    </div>
    <div
      class="site-logo-title__sub"
    >
      Compte Rendu d'Activité pour Freelances en régie
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss">
  @use './index.scss';
</style>